export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-50/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl font-bold font-heading text-background-50">51黑料</span>
              <span className="text-xs bg-accent-500 text-background-50 px-2 py-0.5 rounded-md font-medium">
                吃瓜
              </span>
            </div>
            <p className="text-sm leading-relaxed">
              51黑料是国内领先的娱乐八卦视频聚合平台，提供最新最全的黑料视频与吃瓜视频内容。51黑料在线观看，高清流畅不卡顿，随时随地掌握娱乐八卦第一手资讯。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#media" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">精彩视频</a>
              <a href="#cards" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">热门推荐</a>
              <a href="#index" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">热门专题</a>
              <a href="#ranking" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">热度排行</a>
              <a href="#updates" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">最新快讯</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门内容</h4>
            <div className="space-y-2">
              <a href="#cards" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">51黑料在线观看</a>
              <a href="#media" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">51黑料视频</a>
              <a href="#media" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">51黑料吃瓜视频</a>
              <a href="#index" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">黑料视频观看</a>
              <a href="#topics" className="block text-sm hover:text-accent-400 transition-colors cursor-pointer">51黑料网视频</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40">更多合作伙伴即将入驻</p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 51黑料. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#about" className="text-xs hover:text-accent-400 transition-colors cursor-pointer">关于我们</a>
              <a href="#contact" className="text-xs hover:text-accent-400 transition-colors cursor-pointer">联系我们</a>
              <a href="#faq" className="text-xs hover:text-accent-400 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}